import React from 'react';
import BuyerFeesModal from '@components/buyer-fees/buyer-fees-modale/buyer-fees-modale';
import Icon from '@components/atoms/icon/icon';
import { MinimumPricingBreakdown } from '@interfaces/pricingBreakdown';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import styles from './product-price-seller.module.scss';
import priceStyles from './../product-price.module.scss';

export type ProductPriceSellerProps = {
  breakdown: MinimumPricingBreakdown;
  isSold?: boolean;
  buyerLocation?: string;
  productId: string;
};

const ProductPriceSeller: React.FC<ProductPriceSellerProps> = ({
  breakdown,
  isSold = false,
  buyerLocation,
  productId,
}) => {
  const { sellerPrice, sellerInitialPrice, sellerEarning, fullPrice } = breakdown;
  const { t } = useTranslation();
  const { t: tA11y } = useTranslation('a11y');
  const hasPromotionApplied = sellerInitialPrice && sellerInitialPrice.cents > 0;

  return (
    <div className={styles.sellerPrice}>
      <p className={clsx(styles.sellerPrice__main, { [styles['sellerPrice__main--sold']]: isSold })}>
        {hasPromotionApplied && (
          <span
            className={priceStyles['productPrice__price--strikeOut']}
            data-cy="product_price_drop"
          >
            {sellerInitialPrice.formatted}
          </span>
        )}
        <span
          className={clsx(
            styles.sellerPrice__sellerPrice,
            hasPromotionApplied && priceStyles['productPrice__price--promo'],
          )}
          data-cy="product-price-seller-deposit"
        >
          {isSold ? (
            <>
              {t('PRODUCT.DETAILS.SOLD.RESERVED', {
                price_formatted: sellerPrice.formatted,
              })}
            </>
          ) : (
            <>{sellerPrice.formatted}</>
          )}
        </span>{' '}
        <span
          className={styles.sellerPrice__sellerEarning}
          data-cy="product-price-seller-earning"
        >
          {isSold ? (
            <>{t('PRODUCT.PRICE.SELLER.YOU_EARNED', { price: sellerEarning.formatted })}</>
          ) : (
            <>{t('PRODUCT.PRICE.SELLER.YOU_EARN', { price: sellerEarning.formatted })}</>
          )}
        </span>
      </p>
      {!isSold && (
        <p
          className={styles.sellerPrice__buyerFees}
          data-cy="product-price-seller-public-price"
        >
          {t('PRODUCT.PRICE.INCLUDED_BUYERSERVICEFEE', { price: fullPrice.formatted })}
          <BuyerFeesModal
            breakdown={breakdown}
            isSeller={true}
            buyerLocation={buyerLocation}
            trackingContext="pdp"
            productId={productId}
          >
            <Icon
              name="infobox-default"
              data-cy="sellerPrice__buyerFees__InfoBox"
              ariaLabel={tA11y('A11Y.ICON.INFO_SELLER_FEE')}
            />
          </BuyerFeesModal>
        </p>
      )}
    </div>
  );
};

export default ProductPriceSeller;
